import { SET_CUSTOMER_NAME_REQUEST, SET_CUSTOMER_NAME_SUCCESS, SET_CUSTOMER_NAME_FAILURE } from '../constants/customer_name.constants';

export const setCustomerNameRequest = (_id, customer_name) => ({
    type: SET_CUSTOMER_NAME_REQUEST, _id, customer_name,
});
export const setCustomerNameSuccess = (_id, customer_name) => ({ type: SET_CUSTOMER_NAME_SUCCESS, _id, customer_name });
export const setCustomerNameFailure = error => ({ type: SET_CUSTOMER_NAME_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/set_customer_name.actions.js